import { Button } from "@dash/form";
import { SelectDropdown } from "@dash/select";
import React from "react";
import { MdOutlineFileDownload } from "react-icons/md";

import { ExportFormat, exportFormats } from "./exportReport";

const formatLabels: Record<ExportFormat, string> = {
  html: "HTML",
  pdf: "PDF",
  csv: "CSV",
  ipynb: "Jupyter (.ipynb)",
};

export const DownloadReportMenu: React.FC<{ onDownload: (format: ExportFormat) => void; isDisabled: boolean }> = ({
  onDownload,
  isDisabled,
}) => (
  <SelectDropdown
    trigger={
      <Button as="div" variant="outline" icon={<MdOutlineFileDownload />} isDisabled={isDisabled}>
        Pobierz
      </Button>
    }
    value={null}
    options={exportFormats.map((format) => ({ value: format, label: formatLabels[format] }))}
    onChange={(format) => onDownload(format as ExportFormat)}
    isDisabled={isDisabled}
  />
);
